module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/sp/relation_link_senior_down-845c8cbf132c92b407519499327afb57.png";